<template>
  <div>
    <div class="relative mt-34">
      <div
        class="lg:py-12 md:py-10 py-6 md:w-4/5 lg:w-4/5 w-full md:px-0 lg:px-0 px-6 mx-auto lg:flex md:flex gap-4 justify-between items-center"
      >
        <p
          class="title sm-fsize20 md:font-normal lg:font-normal font-bold lg:mb-0 md:mb-0 mb-4"
        >
          Our Impact
        </p>
        <!-- "https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/all-in-one/Impact%20Report%202021v%201.0.pdf"  -->

        <div class="flex lg:gap-4 md:gap-4 gap-2 justify-between items-center">
          <div class="">
            <!-- <label for="year" class="mr-2">Select Year:</label> -->
            <select
              id="year"
              v-model="selectedYear"
              placeholder="Select Year"
              class="border rounded-md px-3 py-2 sm-fsize12 focus:outline-none focus:ring focus:border-blue-300"
            >
              <option value="" disabled hidden>Select Year</option>
              <option v-for="year in availableYears" :key="year" :value="year">
                {{ year }}
              </option>
            </select>
          </div>
          <!-- href="https://nimbuscluster.blob.core.windows.net/server01/image/Caregiver%20Saathi%20Impact%20_Annual%20Report%202023.pdf" -->
          <a :href="getImpactReportUrl(selectedYear)" target="blank">
            <b-button
              variant="primary"
              class="lg:px-12 md:px-12 lg:py-3 md:py-3 sm-fsize12 md-fsize14 fsize16"
              :disabled="!selectedYear"
              :class="{ 'cursor-not-allowed opacity-50': !selectedYear }"
              @click="handleButtonClick"
            >
              Our Impact Report</b-button
            ></a
          >
          <div class="mt-4 flex items-center gap-2">
            <!-- v-b-modal.modal-1
              @click="dialogVisible = true" -->
            <img
              src="./../../../assets/images/share.png"
              alt="ShareIcon"
              class="lg:h-5 lg:w-5 md:h-6 md:w-6 w-4 h-4 cursor-pointer"
              :disabled="!selectedYear"
              :class="{ 'cursor-not-allowed opacity-50': !selectedYear }"
              @click="openShareModal"
            />
          </div>
          <b-modal
            id="modal-1"
            title="Share"
            centered
            hide-footer
            v-model="showModal"
          >
            <div class="d-flex justify-content-around mb-3">
              <a
                :href="`https://facebook.com/share.php?u=${copy}`"
                target="_blank"
              >
                <img
                  class="w-10 h-10 cursor-pointer"
                  src="../../../assets/icons/facebook.svg"
                  alt="Facebook"
                />
              </a>
              <a
                :href="`https://linkedin.com/sharing/share-offsite/?url=${copy}`"
                target="_blank"
              >
                <img
                  class="w-10 h-10 cursor-pointer"
                  src="../../../assets/icons/Linkedin.svg"
                  alt="LinkedIn"
                />
              </a>
              <a :href="`mailto:?body=${copy}`" target="_blank">
                <img
                  class="w-10 h-10 cursor-pointer"
                  src="../../../assets/icons/Mail.svg"
                  alt="Mail"
                />
              </a>
              <a
                :href="`https://api.whatsapp.com/send?text=${copy}`"
                target="_blank"
              >
                <img
                  class="w-10 h-10 cursor-pointer"
                  src="../../../assets/icons/Whatsapp.svg"
                  alt="WhatsApp"
                />
              </a>
              <a
                :href="`https://twitter.com/share?text=Check%20this%20out&url=${copy}`"
                target="_blank"
              >
                <img
                  class="w-10 h-10 cursor-pointer"
                  src="../../../assets/icons/Twitter.svg"
                  alt="Twitter"
                />
              </a>
            </div>

            <!-- Copy Link Section -->
            <b-input-group size="md" class="mb-2">
              <b-form-input type="text" v-model="copy" readonly></b-form-input>
              <b-input-group-prepend
                is-text
                class="cursor-pointer textstyle"
                @click="copyToClipboard"
              >
                COPY
              </b-input-group-prepend>
            </b-input-group>

            <!-- Copy Confirmation -->
            <p v-if="copySuccess" class="text-green-500 text-sm mt-2">
              Link copied!
            </p>
          </b-modal>
        </div>
        <!-- <div class="mt-10">
          <div class="grid grid-cols-2 grid-rows-2 md:gap-8 lg:gap-8 gap-4">
            <div
              class="card1bg md:px-8 lg:px-8 px-3 md:pb-10 lg:pb-10 pb-3 md:pt-12 lg:pt-12 pt-3 rounded-xl"
              v-for="(item, index) in impact"
              :key="index"
              :style="{ 'background-color': item.color }"
            >
              <div class="flex-wrap flex cust-flex-reverse">
                <div class="md:w-1/2 lg:w-1/2 w-full">
                  <p
                    class="text-xl text-black font-semibold md:pb-2 lg:pb-2 fsize20-16"
                  >
                    {{ item.text }}
                  </p>
                  <p
                    class="text-lg pt-1 lh32px font-normal ellipsis-5 fsize18-14px"
                  >
                    {{ item.subtitle }}
                  </p>
                </div>
                <div class="md:w-1/2 lg:w-1/2 w-full px-0">
                  <img :src="item.img" alt="" class="frameht" />
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="lg:mb-12 md:mb-12 bg-cbedf2">
      <div
        class="grid lg:grid-cols-5 md:grid-cols-3 grid-cols-1 gap-4 lg:px-12 md:px-12 py-8 lg:my-0 md:my-0 my-8"
      >
        <div
          v-for="(item, index) in impactNo"
          :key="index"
          class="cust-fsize35 md-fsize22 p-4 text-center"
        >
          <div class="flex items-center justify-center">
            <countTo
              :startVal="item.start"
              :endVal="item.end"
              :duration="3000"
              :style="{ color: item.color }"
            ></countTo>
            <feather-icon
              icon="PlusIcon"
              class="cursor-pointer font-bold"
              :style="{ color: item.color }"
            />
          </div>

          <p class="abtus-impact-desc md-fsize18 pb-1 pt-2 text-center">
            {{ item.desc }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import countTo from "vue-count-to";
export default {
  components: {
    countTo,
  },
  data() {
    return {
      // dialogVisible: false
      showModal: false,
      copy: "",
      copyText: "",
      copySuccess: false,
      impact: [
        {
          id: "01",
          text: "Lorem Ipsum Dolor",
          subtitle:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
          color: "#e3ceff66",
          img: require("../../../assets/images/walker frame.svg"),
        },
        {
          id: "02",
          text: "Lorem Ipsum Dolor",
          subtitle:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
          color: "#f1f1f199",
          img: require("../../../assets/images/yoga frame.svg"),
        },
        {
          id: "03",
          text: "Lorem Ipsum Dolor",
          subtitle:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
          color: "#f1f1f199",
          img: require("../../../assets/images/staff frame.svg"),
        },
        {
          id: "04",
          text: "Lorem Ipsum Dolor",
          subtitle:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
          color: "#e3ceff66",
          img: require("../../../assets/images/thanks frame.svg"),
        },
      ],
      impactNo: [
        {
          start: 0,
          end: 33814,
          desc: "Our Community Size",
          color: "#00ADC0",
          linecolor: "#CCEFF2",
        },
        {
          start: 0,
          end: 911,
          desc: "Lives of Caregivers Touched",
          color: "#8383FF",
          linecolor: "#EEE2FF",
        },
        {
          start: 0,
          end: 186,
          desc: "Benevolent Donors",
          color: "#00ADC0",
          linecolor: "#CCEFF2",
        },
        {
          start: 0,
          end: 1880,
          desc: "Volunteers",
          color: "#8383FF",
          linecolor: "#EEE2FF",
        },
        {
          start: 0,
          end: 12,
          desc: "Corporate Clients",
          color: "#00ADC0",
          linecolor: "#CCEFF2",
        },
      ],
      selectedYear: "",
      availableYears: ["2021", "2022-2023", "2024-2025"],
      reportMap: {
        2021: "Impact Report (1).pdf",
        "2022-2023": "Caregiver Saathi Impact _Annual Report 2023.pdf",
        "2024-2025": "Impact Report 2024 - 2025_.pdf",
      },
    };
  },
  methods: {
    // getImpactReportUrl(year) {
    //   const baseURl =
    //     "https://nimbuscluster.blob.core.windows.net/server01/image/";
    //   const reportMap = {
    //     // 2020: "",
    //     // 2021: "",
    //     2022: "Final%20letter%20-%20determinant%20-%20Friends%20of%20Caregiver%20Saathi.pdf",
    //     2023: "Caregiver%20Saathi%20Impact%20_Annual%20Report%202023.pdf",
    //     // 2024: "",
    //     // 2025: "",
    //   };
    //   if (!year || !reportMap[year]) return "#";
    //   return baseURl + (reportMap[year] || "");
    // },

    openShareModal() {
      console.log("9999");
      if (!this.selectedYear) return;
      this.copy = this.copyPath;
      this.copyText = this.copyPath;
      this.showModal = true;
    },

    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.copyText);
        this.copySuccess = true;
        setTimeout(() => (this.copySuccess = false), 2000);
      } catch (err) {
        console.error("Clipboard copy failed: ", err);
      }
    },

    handleButtonClick() {
      if (!this.selectedYear) return;

      window.open(this.getImpactReportUrl(this.selectedYear), "_blank");
    },
    getImpactReportUrl(year) {
      console.log("222222");
      if (!this.reportMap[year]) return "#";

      let path = this.reportMap[year];
      // let path = "Impact Report 2024 - 2025_.pdf";
      let formattedPath = path.replace(/ /g, "-");
      let fullPath = `${process.env.VUE_APP_BASE_URL_CORE_API}files/${formattedPath}`;
      this.copyPath = fullPath;
      console.log(fullPath, "222222");
      return fullPath;
      // const baseUrls = {
      //   // base1: "https://nimbuscluster.blob.core.windows.net/server01/image/",
      //   // base2:
      //   //   "https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi-new/",
      //   base3:
      //     "https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/",
      // };
      // const reportMap = {
      //   2021: {
      //     file: "Impact%20Report%20(1).pdf",
      //     base: "base3",
      //   },
      //   2023: {
      //     file: "Caregiver%20Saathi%20Impact%20_Annual%20Report%202023.pdf",
      //     base: "base1",
      //   },
      //   2025: {
      //     file: "Impact%20Report%202024%20-%202025_.pdf",
      //     base: "base3",
      //   },
      // };

      // // if (!year || !reportMap[year]) return "#";
      // // const { file, base } = reportMap[year];
      // // return baseUrls[base] + file;
      // if (!year) return this.getImpactReportUrl("2021");
      // const years = year.split("-");

      // for (const y of years) {
      //   if (reportMap[y]) {
      //     const { file, base } = reportMap[y];
      //     return baseUrls[base] + file;
      //   }
      // }

      // return "#";
    },

    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
<style>
.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group
  > .input-group-prepend:first-child
  > .input-group-text:not(:first-child) {
  background: #4f0a4b;
  color: white;
}
</style>
 